import React from "react";
import PropTypes from "prop-types";
import DropdownMenu from "common/components/dropdown_menu";

const Menu = ({
  isLoggedIn,
  isCreative,
  isClient,
  watch,
  category,
  subCategory,
  user,
  project,
  unwatch,
}) => {
  const papLink = subCategory.deprecated
    ? "/start-a-project/"
    : `/start-a-project/${category.slug}/${subCategory.slug}/details/package/`;
  const watching = (user.watchlist_ids || []).includes(project.id);

  const buttons = [
    {
      url: papLink,
      label: (
        <span>
          <i className="fa fa-fw fa-arrow-right" />
          Start a project like this
        </span>
      ),
      show: !isLoggedIn || isClient,
    },
    {
      show: isCreative,
      action: watching ? unwatch : watch,
      label: (
        <span>
          <i className="fa fa-fw fa-eye" />
          {watching ? "Unwatch" : "Watch"}
        </span>
      ),
    },
  ];

  return (
    <DropdownMenu buttons={buttons} className="hide-for-small-only right" />
  );
};

Menu.propTypes = {
  isLoggedIn: PropTypes.bool,
  isCreative: PropTypes.bool,
  isClient: PropTypes.bool,
  watch: PropTypes.func.isRequired,
  unwatch: PropTypes.func.isRequired,
  category: PropTypes.object,
  subCategory: PropTypes.object,
  project: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default Menu;
